module.exports = __webpack_public_path__ + "cd606604395a0724aeb575b30d2313e7.jpg";